import { CONSULT_TYPES } from '@repo/app-constants';

import { Consult } from 'types/Consult';

const DEFAULT_GROUP_DURATION_MINUTES = 60;
const DEFAULT_INDIVIDUAL_DURATION_MINUTES = 30;

export const getConsultDurationMinutes = (
  consult: Pick<Consult, 'duration_minutes' | 'type'>,
): number => {
  if (consult.duration_minutes != null) return consult.duration_minutes;

  return consult.type === CONSULT_TYPES.GROUP_RESULTS_REVIEW_CUSTOMER
    ? DEFAULT_GROUP_DURATION_MINUTES
    : DEFAULT_INDIVIDUAL_DURATION_MINUTES;
};
